import { render, staticRenderFns } from "./ItensUnidade.vue?vue&type=template&id=f8610c62"
import script from "./ItensUnidade.vue?vue&type=script&lang=js"
export * from "./ItensUnidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports